import { render, staticRenderFns } from "./communitySpaceConfirmList.vue?vue&type=template&id=71e6b194&scoped=true"
import script from "./communitySpaceConfirmList.vue?vue&type=script&lang=js"
export * from "./communitySpaceConfirmList.vue?vue&type=script&lang=js"
import style0 from "./communitySpaceConfirmList.vue?vue&type=style&index=0&id=71e6b194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e6b194",
  null
  
)

export default component.exports